"use strict";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useContentChannel } from "../../components";
import { MenuButton, Buttons } from "capitalrx-components-2.0/lib/general";
import * as Color from "capitalrx-components-2.0/lib/general/Color";
import styles from "./Actions.module.css";
const CustomAppearance = {
  ...Buttons.Functional.Tertiary.Large,
  padding: {
    horizontal: 12,
    vertical: 4
  },
  label: {
    ...Buttons.Functional.Tertiary.Large.label,
    uppercase: false,
    weight: "regular",
    letterSpacing: 0,
    lineHeight: 24
  },
  normal: {
    ...Buttons.Functional.Tertiary.Large.normal,
    foregroundColor: Color.White,
    textUnderline: false
  },
  hover: {
    ...Buttons.Functional.Tertiary.Large.hover,
    foregroundColor: Color.White,
    backgroundColor: Color.withAlpha(Color.Turqoise["800"], 0.25),
    borderColor: Color.withAlpha(Color.White, 0.5),
    textUnderline: false
  },
  pressed: {
    ...Buttons.Functional.Tertiary.Large.pressed,
    foregroundColor: Color.White,
    backgroundColor: Color.withAlpha(Color.White, 0.1),
    textUnderline: false
  },
  disabled: {
    ...Buttons.Functional.Tertiary.Large.disabled,
    foregroundColor: Color.White,
    textUnderline: false
  }
};
export const Actions = () => {
  const subscriptions = useContentChannel(null, "global-actions");
  return /* @__PURE__ */ jsxs("div", { className: `${styles.root} actions`, children: [
    subscriptions.length === 1 && /* @__PURE__ */ jsx(Fragment, { children: subscriptions.map((subscription, index) => {
      const { component: Component } = subscription;
      return /* @__PURE__ */ jsx(Component, {}, index);
    }) }),
    subscriptions.length > 1 && /* @__PURE__ */ jsx(MenuButton, { label: "Account", appearance: CustomAppearance, tabIndex: 5, children: subscriptions.map((subscription, index) => {
      const { component: Component } = subscription;
      return /* @__PURE__ */ jsx(MenuButton.ComponentItem, { style: { padding: 0 }, children: /* @__PURE__ */ jsx(Component, {}) }, index);
    }) })
  ] });
};
